import User from '../User';
import { ajax, stringifyParams } from '../lib';

export default class QuizVoltaire {
    player: User | undefined = undefined;
    quizId: string | undefined | null = undefined;
    quizResult: boolean | undefined | null = undefined;
    quizAnswer: string | null = null;

    constructor() {}

    init() {
        this.initQuizId();
        // Player's info
        this.player = new User();

        if (this.player.isConnected) {
            if (!this.player.isPremium) {
                // Display CTA Je m'abonne (section id="not subscribed")
                this.displaySection('not-subscribed');
            } else {
                // Check if player already played or not
                if (this.alreadyPlayed()) {
                    this.showQuizResult();
                } else {
                    this.showQuiz();
                }
            }
        } else {
            // Display CTA Je me connecte and CTA Je m'abonne (section id="not connnected" and keep other sections hidden )
            this.displaySection('not-connected');
        }
    }
    initQuizId() {
        const oldQuizId = localStorage.getItem('quizId');
        // Collect data-quiz-id attribute from DOM and save it in localStorage
        this.quizId = document
            ?.getElementById('quiz-voltaire')
            ?.getAttribute('data-quiz-id');
        if (this.quizId) {
            localStorage.setItem('quizId', this.quizId);
        }
        if (oldQuizId !== this.quizId) {
            localStorage.removeItem('quizSlug');
            localStorage.removeItem('quizResult');
            localStorage.removeItem('quizAnswer');
        }
    }
    alreadyPlayed() {
        if (this.player?.isConnected && this.player?.isPremium) {
            return localStorage.getItem('quizSlug');
        } else {
            return false;
        }
    }
    showQuiz() {
        // question section to display
        this.displaySection('question');

        const options = Array.from(
            document.querySelectorAll('[data-quiz-resp]')
        );
        const handleClick = (i: number, quiz: QuizVoltaire) => () => {
            const clickedSlug = options[i].getAttribute('data-quiz-resp');
            localStorage.setItem('quizSlug', clickedSlug!);

            // send user answer to server
            quiz.sendWord(clickedSlug!);
        };
        for (let i = 0; i < options.length; i++) {
            options[i].addEventListener('click', handleClick(i, this));
        }
    }
    sendWord(word: string) {
        const formData = {
            verif: '1',
            slug: word,
            'id-quiz': this.quizId,
        };

        const req = ajax(
            'POST',
            'https://www.lepoint.fr/html/quiz/quiz-repondre.php',
            stringifyParams(formData)
        );
        req.then((data: any) => {
            data = JSON.parse(data.response);
            if (data.status === 'OK') {
                localStorage.setItem('quizResult', data.correct);
                // hide question section
                const sectionToHide = document.getElementById('question');
                if (sectionToHide != null) {
                    sectionToHide.style.display = 'none';
                }
                this.quizAnswer = data.word;
                localStorage.setItem('quizAnswer', data.word);
                Array.from(
                    document.getElementsByClassName('green-word')
                ).forEach(element => {
                    element.textContent = data.word;
                });
                if (data.correct) {
                    this.displayRightAnswerSection();

                    xt_click(
                        this,
                        'C',
                        '214',
                        `voltaire::question_${data.word_search}::bonne_reponse_${word}`,
                        'A'
                    );
                } else {
                    this.displayWrongAnswerSection();
                    xt_click(
                        this,
                        'C',
                        '214',
                        `voltaire::question_${data.word_search}::mauvaise_reponse_${word}`,
                        'A'
                    );
                }
            } else if (data.status === 'KO') {
                if (data.id === this.quizId) {
                    // request or connexion problem
                    console.error('request or connexion problem');
                } else if (data.id !== this.quizId) {
                    // front end sent old quizId
                    console.error("This is an old quizId, we'got a new one");
                }
            }
        });
    }
    displayRightAnswerSection() {
        this.displayAnswerSection('right-answer', 'final-right-answer');
    }
    displayWrongAnswerSection() {
        this.displayAnswerSection('wrong-answer', 'final-wrong-answer');
    }
    displayAnswerSection(fromId: string, toId: string) {
        const sectionToDisplay = document.getElementById(fromId);
        if (sectionToDisplay !== null) {
            sectionToDisplay.style.display = 'flex';
        }
        const sectionToDisplayAfter = document.getElementById(toId);
        if (sectionToDisplay !== null && sectionToDisplayAfter !== null) {
            sectionToDisplay.style.display = 'flex';
            setTimeout(() => {
                sectionToDisplay.style.display = 'none';
                sectionToDisplayAfter.style.display = 'flex';
            }, 2000);
        }
    }
    showQuizResult() {
        this.quizAnswer = localStorage.getItem('quizAnswer');
        if (this.quizAnswer) {
            if (localStorage.getItem('quizResult') === 'true') {
                // user have won
                this.displaySection('final-right-answer');
            } else {
                // user have lost
                this.displaySection('final-wrong-answer');
                Array.from(
                    document.getElementsByClassName('green-word')
                )[1].textContent = this.quizAnswer;
            }
        }
    }
    displaySection(id: string) {
        const sectionToDisplay = document.getElementById(id);
        if (sectionToDisplay) {
            sectionToDisplay.style.display = 'flex';
        }
    }
}